/**
 * 🌀 CONDUCTANCE MONOLITH v1.2.0nm
 * Protocol: Visual Manifestation of Capital
 * Filter: 60.05% Phasic Resonance
 */

import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

export const ConductanceMonolith: React.FC<{ manifest: number }> = ({ manifest }) => {
  const meshRef = useRef<THREE.Mesh>(null!);
  const TARGET = 43710000;
  const ratio = Math.min(manifest / TARGET, 1);

  // 🌀 Rotation & Pulsation Logic
  useFrame((state) => {
    const time = state.clock.getElapsedTime();
    meshRef.current.rotation.y = time * 0.2;
    // Pulse scale based on current resonance
    const pulse = 1 + Math.sin(time * 2) * 0.02 * ratio;
    meshRef.current.scale.set(pulse, pulse, pulse);
  });

  return (
    <group>
      {/* The Core Monolith */}
      <mesh ref={meshRef}>
        <boxGeometry args={[2, 4 * ratio, 2]} />
        <meshStandardMaterial 
          color={ratio > 0.99 ? "#FFD700" : "#0070FF"} 
          emissive={ratio > 0.99 ? "#FFD700" : "#002244"}
          emissiveIntensity={2 * ratio}
          metalness={1}
          roughness={0.1}
        />
      </mesh>

      {/* The Ambient Field (Conductance Glow) */}
      <mesh scale={[2.2, 4.2 * ratio, 2.2]}>
        <boxGeometry args={[1, 1, 1]} />
        <meshBasicMaterial 
          color={ratio > 0.5 ? "#00FFCC" : "#0070FF"} 
          transparent 
          opacity={0.1 * ratio} 
        />
      </mesh>
    </group>
  );
};